"use strict";

/*global  jQuery*/

jQuery(function ($) {
  "use strict";

    /*
  --------------------------------------
   スムーズスクロール
   #で始まるアンカーをクリックした場合に処理
   必要に応じて除外する要素を追記すること
  --------------------------------------
  */
  $(document).on('click', 'a[href*=\\#]:not([href=\\#],.popup)', function (event) {
      // アンカーの値取得
      var href = $(this).attr("href"),
      // 移動先を取得 velocity
      target = $(href === "#" || href === "" ? 'html' : href);
    // スムーススクロール
    target.velocity("scroll", 500);
    // 移動先を数値で取得 animate
//    target = $(href === "#" || href === "" ? 'html' : href),
//    position = target.offset().top;
    // スムーススクロール
//    $('body,html').animate({scrollTop: position}, speed, 'swing');
    return false;
  });
    /*
  --------------------------------------
   スクロール処理
   waypoint
  --------------------------------------
  */
  $(".demo-waypoint").waypoint(function () {
    $(".demo-waypoint").addClass("animated rubberBand");
  }, { offset: '20%' });
  
  $(".page00").waypoint(function () {
    $(".page00 .catch").addClass("animated fadeInUp");
  }, { offset: '0%' });
  
  $(".page01").waypoint(function () {
    $(".page01 .catch").addClass("animated jackInTheBox");
  }, { offset: '40%' });

  $(".page02").waypoint(function () {
    $(".page02 .catch").addClass("animated jackInTheBox");
  }, { offset: '40%' });

  $(".page03").waypoint(function () {
    $(".page03 .catch").addClass("animated jackInTheBox");
  }, { offset: '40%' });
  
  $(".page04").waypoint(function () {
    $(".page04 .catch").addClass("animated jackInTheBox");
  }, { offset: '70%' });
  
  
});